import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import constants from "constants/constants";
import messages from "constants/messages";

import { getStartDay, loginUser } from "../lib/auth-api";
import {
  clearRememberedUsername,
  getAuthenticatedRoute,
  getRememberedUsername,
  persistLoginSession,
  setRememberedUsername
} from "../lib/auth-session";

const {
  PAGE_ROUTES: { LOGIN_ROUTE }
} = constants;

const { LOGIN_ERROR } = messages;

export const useLogin = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const navigateTo = getAuthenticatedRoute();

    if (navigateTo) {
      navigate(navigateTo);
    }
  }, [navigate]);

  const handleSubmit = async values => {
    const { password, remember, username } = values;

    setLoading(true);
    setMessage("");

    const preservedUsername = getRememberedUsername();
    localStorage.clear();
    if (preservedUsername) {
      setRememberedUsername(preservedUsername);
    }

    try {
      const response = await loginUser({ password, username });
      const { navigateTo, sessionKey } = persistLoginSession(response.data, remember);
      const startDayResponse = await getStartDay(sessionKey);

      localStorage.setItem(
        "day",
        JSON.stringify(startDayResponse?.data?.PlatformDefaultFirstDayOfWeek)
      );

      if (remember) {
        setRememberedUsername(username);
      } else {
        clearRememberedUsername();
      }

      window.location.replace(navigateTo);
    } catch (error) {
      setMessage(LOGIN_ERROR);
      navigate(LOGIN_ROUTE);
    } finally {
      setLoading(false);
    }
  };

  return {
    handleSubmit,
    loading,
    message
  };
};
